<template>
  <div><InfoCollection :show-success="true" /></div>
</template>
<script>
  // !此收集已废弃 - 2023-05-22
  import InfoCollection from '@/components/InfoCollection/InfoCollection.vue'
  import { wxShare } from '@/utils'
  import store from '@/store'
  export default {
    components: {
      InfoCollection,
    },
    data() {
      return {}
    },
    created() {
      this.init()
    },
    methods: {
      async init() {
        const tenant = await store.getters['user/getTenant']
        wxShare(`${tenant.TenantName}`, '客户档案信息表')
      },
    },
  }
</script>
<style lang="scss" scoped></style>
